(function($) {
'use strict';
    $.fn.autofocus_input = function() {

        return this.each(function() {
            var input = $(this).find('[data-autofocus="input"]');

            input.on('input', function(){
                var input_current = $(this),
                    input_length = input_current.val().length,
                    max_length = input_current.attr('max').length,
                    index_current = input.index(input_current);

                if( input_length === max_length && index_current < ( input.length - 1 ) ){
					input[index_current+1].focus();
                }
            });
        });
    }
})(jQuery);

$(document).ready(function () {
    $('[data-autofocus="container"]').autofocus_input();
});
